/**
 * assets/quick-add-size-selector.js
 *
 * Abre/cierra el selector de talles inline de la tarjeta de producto y,
 * al elegir un talle, reutiliza el <product-form> que ya existe en la
 * tarjeta (el mismo que arma Dawn): pone el id de la variante en el input
 * oculto y dispara el submit real, así product-form.js sigue haciendo el
 * fetch a /cart/add.js, el spinner y la actualización del cart-drawer o
 * cart-notification. Este script NO llama a /cart/add.js por su cuenta.
 */

(function () {
  // Blindaje anti-superposición: si algún otro elemento del tema (un link
  // "stretched" con ::before, un overlay, etc.) tapa visualmente alguno de
  // nuestros botones y se queda con el clic, lo interceptamos en fase de
  // captura y lo redirigimos al botón real. No depende de z-index ni de
  // conocer la estructura del resto de la tarjeta: mira directamente qué
  // hay apilado en el punto exacto donde se hizo clic.
  document.addEventListener(
    'click',
    function (event) {
      const ownTarget = event.target.closest(
        '.product-item__quick_add_button, .close-variants, .product-item__quick_add_button--variant'
      );
      if (ownTarget) return; // ya le llegó al botón correcto, no hacemos nada

      if (typeof document.elementsFromPoint !== 'function') return;

      const stack = document.elementsFromPoint(event.clientX, event.clientY);
      const covered = stack.find(
        (el) =>
          el.classList &&
          (el.classList.contains('product-item__quick_add_button') ||
            el.classList.contains('close-variants') ||
            el.classList.contains('product-item__quick_add_button--variant'))
      );

      if (!covered || covered.disabled) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      covered.click();
    },
    true
  );

  class QuickAddSizeSelector {
    constructor() {
      document.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const openButton = event.target.closest('.product-item__quick_add_button');
      const closeButton = event.target.closest('.close-variants');
      const variantButton = event.target.closest('.product-item__quick_add_button--variant');

      if (openButton) {
        event.preventDefault();
        this.handleOpen(openButton);
        return;
      }

      if (closeButton) {
        event.preventDefault();
        this.handleClose(closeButton);
        return;
      }

      if (variantButton) {
        event.preventDefault();
        this.handleVariantClick(variantButton);
        return;
      }

      // Clic fuera de un selector abierto: lo cerramos.
      const openForm = document.querySelector('.product-item__form.active');
      if (openForm && !openForm.contains(event.target)) {
        this.closeForm(openForm);
      }
    }

    handleOpen(button) {
      if (button.disabled) return;
      const form = button.closest('.product-item__form');
      if (!form) return;

      // Producto sin variantes reales: agregar directo, sin desplegar talles.
      if (button.dataset.variant === 'default') {
        this.submitVariant(button.dataset.defaultVariantId, button);
        return;
      }

      // Cerrar cualquier otro selector abierto en la grilla.
      document.querySelectorAll('.product-item__form.active').forEach((openForm) => {
        if (openForm !== form) this.closeForm(openForm);
      });

      form.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }

    handleClose(button) {
      const form = button.closest('.product-item__form');
      if (form) this.closeForm(form);
    }

    closeForm(form) {
      form.classList.remove('active');
      const openButton = form.querySelector('.product-item__quick_add_button');
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
    }

    handleVariantClick(button) {
      if (button.disabled || button.classList.contains('unavailable')) return;
      this.submitVariant(button.dataset.variantId, button);
    }

    submitVariant(variantId, triggerButton) {
      if (!variantId) return;

      const form = triggerButton.closest('form');
      if (!form) return;

      const idInput = form.querySelector('[name="id"]');
      const submitButton = form.querySelector('[type="submit"]');
      if (!idInput || !submitButton) return;

      // product-form.js pone aria-disabled="true" en el submit mientras la
      // petición está en curso; lo usamos para no disparar dos veces.
      if (submitButton.getAttribute('aria-disabled') === 'true') return;

      idInput.value = variantId;
      triggerButton.classList.add('is-adding');

      const observer = new MutationObserver(() => {
        if (submitButton.getAttribute('aria-disabled') !== 'true') {
          observer.disconnect();
          triggerButton.classList.remove('is-adding');

          const soldOutMessage = submitButton.querySelector('.sold-out-message');
          const failed = soldOutMessage && !soldOutMessage.classList.contains('hidden');

          if (failed) {
            triggerButton.classList.add('unavailable');
            triggerButton.disabled = true;
          } else {
            this.showAdded(triggerButton);
          }
        }
      });
      observer.observe(submitButton, { attributes: true, attributeFilter: ['aria-disabled'] });

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitButton);
      } else {
        submitButton.click();
      }
    }

    showAdded(button) {
      const isVariantButton = button.classList.contains('product-item__quick_add_button--variant');
      const originalLabel = button.dataset.originalLabel || button.textContent;

      button.classList.add('is-added');
      if (isVariantButton) button.textContent = 'Añadido';

      setTimeout(() => {
        button.classList.remove('is-added');
        if (isVariantButton) button.textContent = originalLabel;
        const form = button.closest('.product-item__form');
        if (form) this.closeForm(form);
      }, 900);
    }
  }

  document.addEventListener('DOMContentLoaded', () => new QuickAddSizeSelector());
})();